import { render, staticRenderFns } from "./Slope.vue?vue&type=template&id=23fcfd62"
import script from "./Slope.vue?vue&type=script&lang=js"
export * from "./Slope.vue?vue&type=script&lang=js"
import style0 from "./Slope.vue?vue&type=style&index=0&id=23fcfd62&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports